module.exports = __webpack_public_path__ + "static/banner_image-bfcab273f40f0c05819979c616997c60.png";